<template>
  <nav :class="{ 'mobile-device-pan-control': app.isMobileDevice }" class="flex flex-col items-center justify-center">
    <template v-if="!RENDERER_MODE">
      <SMIcon
        v-if="!app.isMobileDevice"
        class="keyboard-arrow-up"
        title="Pan Up"
        :class="[baseIconStyles, { active: activePanDirection === PAN.UP }]"
        icon="keyboard_arrow_up"
        @click.prevent.stop="() => zoomManager.panUp()"
      />
      <div class="flex">
        <SMIcon
          v-if="!app.isMobileDevice"
          class="keyboard-arrow-left"
          title="Pan Left"
          :class="[baseIconStyles, { active: activePanDirection === PAN.LEFT }]"
          icon="keyboard_arrow_left"
          @click.prevent.stop="() => zoomManager.panLeft()"
        />
        <SMIcon
          class="md-primary center-focus-strong"
          title="Reset Zoom and Center"
          :class="[baseIconStyles, { active: activePanDirection === PAN.CENTER }]"
          icon="center_focus_strong"
          @click.prevent.stop="zoomManager.zoomAndCenterBox()"
        />
        <SMIcon
          v-if="!app.isMobileDevice"
          class="keyboard-arrow-right"
          title="Pan Right"
          :class="[baseIconStyles, { active: activePanDirection === PAN.RIGHT }]"
          icon="keyboard_arrow_right"
          @click.prevent.stop="() => zoomManager.panRight()"
        />
      </div>
      <SMIcon
        v-if="!app.isMobileDevice"
        class="keyboard-arrow-down"
        title="Pan Down"
        :class="[baseIconStyles, { active: activePanDirection === PAN.DOWN }]"
        icon="keyboard_arrow_down"
        @click.prevent.stop="() => zoomManager.panDown()"
      />
    </template>
    <SMIcon
      v-else
      class="md-primary center-focus-strong"
      title="Reset Zoom and Center"
      :class="{ active: activePanDirection === PAN.CENTER }"
      icon="center_focus_strong"
      @click.prevent.stop="zoomManager.zoomAndCenterBox()"
    />
  </nav>
</template>

<script setup>
import { RENDERER_MODE, PAN } from '@/constants';
import Application from '@/core/application';
import { ref } from 'vue';
import SMIcon from '../ui/SMIcon.vue';

const app = Application.instance;
const zoomManager = app.zoomManager;
const baseIconStyles = 'cursor-pointer';

// TODO: implement active pan direction (animation) again
const activePanDirection = ref(null);
</script>
